"use strict";
exports.__esModule = true;
var filter_logic_1 = require("../../../../report-options2/filter-logic");
function isNodePassFilter(node, filters, filterType) {
    var tagCategories = Object.values(filters);
    for (var _i = 0, tagCategories_1 = tagCategories; _i < tagCategories_1.length; _i++) {
        var tags = tagCategories_1[_i];
        if (!tags.some(function (tag) { return node[filterType] && node[filterType].some(function (t) { return t === tag; }); })) {
            return false;
        }
    }
    return true;
}
exports.isNodePassFilter = isNodePassFilter;
function hideTree(node) {
    var shouldShow = true;
    if ('path' in node && node['path'].length !== 0) {
        shouldShow = false;
    }
    else if ('path' in node && node['path'].length == 0) {
        var childrenStatus = node.children.map(function (childNode) { return hideTree(childNode); });
        shouldShow = childrenStatus.some(function (c) { return c; });
    }
    node.hide = !shouldShow;
    return shouldShow;
}
exports.hideTree = hideTree;
function filterTree(node, filterByTags, filterByDropdowns) {
    var shouldShow = true;
    if (!isNodePassFilter(node, filterByTags, 'tags') ||
        !isNodePassFilter(node, filterByDropdowns, 'dropdownTags')) {
        shouldShow = false;
    }
    else if (node.children && node.children.length > 0) {
        var childrenStatus = node.children.map(function (childNode) { return filterTree(childNode, filterByTags, filterByDropdowns); });
        shouldShow = childrenStatus.some(function (c) { return c; });
    }
    node.hide = !shouldShow;
    return shouldShow;
}
exports.filterTree = filterTree;
function filterNodeMap(nodeMap, filterByTags, filterByDropdowns) {
    var parentPath = new Set();
    var firstLevelNodes = new Set();
    // Traverse all nodes in the map
    Object.values(nodeMap).forEach(function (node) {
        if (node.children && node.children.length > 0) {
            //If you want to hide the first level archived parent nodes if it doesn't have filtered data, remove below logic (first if condition)
            if (node['path'] && node['path'].length == 1) {
                firstLevelNodes.add(node);
            }
            else if (node.parent) {
                node.hide = true;
            }
            else {
                //Portfolio Node, should be visible
                node.hide = false;
            }
        }
        else {
            //when lazyArchive nodes are not expanded, they don't have children thus filter will keep it until expanded
            if (node['path'] && node['path'].length == 1) {
                firstLevelNodes.add(node);
            }
            else if (isNodePassFilter(node, filterByTags, 'tags') &&
                isNodePassFilter(node, filterByDropdowns, 'dropdownTags')) {
                node.hide = false;
                if (node.parent && node['path'] && node['path'].length > 0) {
                    node['path'].forEach(function (pathElement) { return parentPath.add(pathElement); });
                }
            }
            else {
                node.hide = true;
            }
        }
    });
    parentPath.forEach(function (pathElement) {
        var parentNode = nodeMap[pathElement];
        if (parentNode) {
            parentNode.hide = false; // Mark the parent node as visible
        }
    });
    // Mark the first level nodes as visible
    firstLevelNodes.forEach(function (node) {
        node.hide = false;
    });
}
exports.filterNodeMap = filterNodeMap;
function isNodePassExclude(node, excludeByTags) {
    var nodeDropdownTags = node['dropdownTags'] || [];
    var nodeDropdownTagsCoded = nodeDropdownTags.map(function (tag) {
        return decodeURIComponent(tag);
    });
    for (var i = 0; i < excludeByTags.length; i++) {
        if ((node["tags"] && node['tags'].indexOf(excludeByTags[i]) !== -1) || (nodeDropdownTagsCoded && nodeDropdownTagsCoded.indexOf(excludeByTags[i]) !== -1)) {
            return false;
        }
    }
    return true;
}
function excludeBy(node, excludeByTags) {
    var shouldShow = true;
    if (node.children && node.children.length > 0 && !node.hide) {
        var childrenStatus = node.children.map(function (childNode) { return excludeBy(childNode, excludeByTags); });
        shouldShow = childrenStatus.some(function (c) { return c; });
        node.hide = !shouldShow;
    }
    else if (!node.hide) {
        shouldShow = isNodePassExclude(node, excludeByTags);
        node.hide = !shouldShow;
    }
    return !node.hide;
}
exports.excludeBy = excludeBy;
function excludeByNodeMap(nodeMap, excludeByTags) {
    // let shouldShow = true;
    var parentPath = new Set();
    var firstLevelNodes = new Set();
    Object.values(nodeMap).forEach(function (node) {
        //node.children>1 parent having nodes included in filter ahve reached here too, 
        if (node.children && node.children.length > 0) {
            if (node['path'] && node['path'].length == 1) {
                firstLevelNodes.add(node);
            }
            else if (node.parent) {
                node.hide = true;
            }
            else {
                //Portfolio Node, should be visible
                node.hide = false;
            }
        }
        else if (!node.hide) {
            if (node['path'] && node['path'].length == 1) {
                firstLevelNodes.add(node);
            }
            else {
                var shouldShow = isNodePassExclude(node, excludeByTags);
                if (shouldShow) {
                    //node should be visible, passed this exclude tags filter
                    if (node.parent && node['path'] && node['path'].length > 0) {
                        node['path'].forEach(function (pathElement) { return parentPath.add(pathElement); });
                    }
                }
                node.hide = !shouldShow;
            }
        }
    });
    parentPath.forEach(function (pathElement) {
        var parentNode = nodeMap[pathElement];
        if (parentNode) {
            parentNode.hide = false; // Mark the parent node as visible
        }
    });
    // Mark the first level nodes as visible
    firstLevelNodes.forEach(function (node) {
        node.hide = false;
    });
}
exports.excludeByNodeMap = excludeByNodeMap;
function getFilterBy(filterLogic) {
    var tags = {};
    var dropdowns = {};
    if (filterLogic) {
        filterLogic = filterLogic.replace(/[()]/g, '');
        var splittedFilterLogic = filterLogic.split(' ');
        for (var i = 0; i < splittedFilterLogic.length; i++) {
            if (splittedFilterLogic[i].indexOf(':') !== -1) {
                var categoryAndTag = splittedFilterLogic[i].split(':');
                var targetFilter = categoryAndTag.length == 2 ? tags : dropdowns;
                if (categoryAndTag[0] in targetFilter) {
                    targetFilter[categoryAndTag[0]].push(splittedFilterLogic[i]);
                }
                else {
                    targetFilter[categoryAndTag[0]] = [splittedFilterLogic[i]];
                }
            }
        }
    }
    return { tags: tags, dropdowns: dropdowns };
}
exports.getFilterBy = getFilterBy;
function parseSimpleFilterFromString(filterLogic) {
    if (!filterLogic) {
        return;
    }
    return filterLogic.children.map(function (f) {
        if (f instanceof filter_logic_1["default"]) {
            var tags = f.children;
            var name_1 = tags[0].split(':')[0];
            var entries = tags.map(function (t) { return ({ name: t.split(':')[1], selected: true }); });
            return { name: name_1, entries: entries };
        }
        else {
            var _a = f.split(':'), name_2 = _a[0], entry = _a[1];
            return { name: name_2, entries: [{ name: entry, selected: true }] };
        }
    });
}
exports.parseSimpleFilterFromString = parseSimpleFilterFromString;
//# sourceMappingURL=tree-filter.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/app/js/logic/tree-filter.js